import {Injectable} from "@angular/core";

/** Definerer eksterne lenker referert i koden vår.
 * Eksterne lenker er samlet her for enkel oversikt over hvilke eksterne lenker vi operer med.
 * Per i dag kunne denne tjenesten vært def som statiske metoder, men vi tar her høyde for at
 * det i fremtiden kommer behov for tilgang til andre tjenester.
 *
 * Se også {@link BildeRessurser} og {@link RessursAdresser} */
@Injectable({providedIn: 'root'})
export class EksterneLenker {

    readonly hjemmesider = {
        møteledelse: 'https://www.styreplan.no/tema/moeteledelse'
    }

    readonly hjelpesider = {
        flyttProtokoll: 'https://support.styreplan.no/no/article/flytte-en-sak-til-et-annet-mote-1ebywza/',
        behandleSpørreundersøkelseISak: 'https://support.styreplan.no/no/article/styreevaluering-behandle-rapporten-i-et-mote-1unre7n/'
    }

    constructor() {
    }
}
